// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorNotificationToast_root__6OS3p","container":"ErrorNotificationToast_container__KvO2B"};